import { type BasePageParams } from '@/app/urls/url-mapping';
import { type UrlEntry, type UrlRegion } from '@/types';

export type GenericPageParams = {
  urlSegments: string[];
} & BasePageParams;

export const urls: Record<'genericPage', Record<UrlRegion, UrlEntry<''>>> = {
  genericPage: {
    de: '',
    'de-en': '',
    es: '',
    'es-en': '',
    fr: '',
    'fr-en': '',
    gb: '',
    nl: '',
    'nl-en': '',
    pt: '',
    'pt-en': '',
    us: '',
    ww: '',
  },
};
